
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import isNil from 'lodash/isNil';

import Loading from '../../components/common/Loading';
import IfElseComp from '../../components/common/IfElseComp';

import AppNavigation from '../../components/app/AppNavigation';
import AnalyzeDefunctPar from '../../components/analyzeDefunctPar/AnalyzeDefunctPar.state';

const classNames = mergeStyleSets({
    AnalyzeDefunctParPage: {
        height: '100vh',
        width: '100vw'
    },
    content: {
        paddingLeft: 16
    }
});

const Content = ({
    project
}) => {

    return (
        <Stack verticalFill>
            <AppNavigation pageId="analyzeDefunctPar" project={project} />
            <Stack.Item grow>
                <AnalyzeDefunctPar />
            </Stack.Item>
        </Stack>
    );
}

const AnalyzeDefunctParPage = ({
    project,
}) => {
    return (
        <Stack verticalFill className={classNames.AnalyzeDefunctParPage}>
            <Stack.Item grow>
                <IfElseComp
                    cond={!isNil(project)}
                    trueComp={
                        <Content
                            project={project}
                        />
                    }
                    falseComp={<Loading />}
                />
            </Stack.Item>
        </Stack>
    );
}

export default AnalyzeDefunctParPage;
